import {scopedHandler} from 'utils/redux';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [state, effects.initialize()];
		}

		case actions.destroy.type: {
			return [initState, effects.destroy()];
		}

		case actions.openPlacesSuggestion.type: {
			return [state, effects.openPlacesSuggestion(payload)];
		}

		case actions.updateBuildingsQuery.type: {
			const newState = {
				...state,
				buildingsQuery: {...state.buildingsQuery, ...payload},
			};

			return [newState, effects.updateBuildingsQuery(state.buildingsQuery)];
		}

		case actions.updateMap.type: {
			return [state, effects.updateMap()];
		}

		case actions.openBuilding.type: {
			const newState = {
				...state,
				buildingsQuery: {
					...state.buildingsQuery,
					buildingId: payload.buildingId,
					projectBuildingId: payload.projectBuildingId,
				},
			};

			return [newState, effects.selectBuilding(payload)];
		}

		case actions.closeBuilding.type: {
			const newState = {
				...state,
				buildingsQuery: {
					...state.buildingsQuery,
					buildingId: null,
					projectBuildingId: null,
				},
			};

			return [
				newState,
				effects.selectBuilding({buildingId: null, projectBuildingId: null, coords: null}),
			];
		}

		case actions.setMapSource.type: {
			return [
				{...state, buildingsQuery: {...state.buildingsQuery, mapSource: payload}},
				effects.setMapSource(payload),
			];
		}

		case actions.recheckQuery.type: {
			return [state, effects.recheckQuery()];
		}

		case actions._updateBuildingsQuery.type: {
			const newState = {
				...state,
				buildingsQuery: {...state.buildingsQuery, ...payload},
			};

			return [newState, null];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
